const modalProject = (state) => state.modalProject;
const modalInvite = (state) => state.modalInvite;
const projects = (state) => state.projects;
const project = (state) => state.project;
const projectID = (state) => state.project.id;
const notExistsEmails = (state) => state.notExistsEmails;
const projectUsers = (state) => state.projectUsers;

export const getters = {
  modalProject,
  modalInvite,
  projects,
  notExistsEmails,
  project,
  projectID,
  projectUsers,
};
